export default "__VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__"